import { __assign, __awaiter, __generator, __spreadArrays } from "tslib";
import * as format from 'string-format';
import * as moment from 'moment';
import { TimetableActionType, WidgetReferralInfo } from '../bi-logger/bi.const';
import { DailyTimetableSettingsKeys, } from '@wix/bookings-app-builder-settings-const/dist/src/DailyTimeTable/Settings.const';
import { ServiceLocationType, ServiceType, SessionOccupancyStatus, } from '@wix/bookings-uou-types/dist/src';
export var SlotRepeaterState;
(function (SlotRepeaterState) {
    SlotRepeaterState["LOADING"] = "loaderState";
    SlotRepeaterState["LIST"] = "slotRepeaterState";
    SlotRepeaterState["NO_CLASSES"] = "noClassesState";
})(SlotRepeaterState || (SlotRepeaterState = {}));
var createDummyDataSlot = function (_a) {
    var translations = _a.translations, index = _a.index, getLocalizedTime = _a.getLocalizedTime, availableSpots = _a.availableSpots;
    var start = moment()
        .add(index + 1, 'hours')
        .startOf('hour');
    return {
        id: "dummy-slot-id-" + (index + 1),
        service: {
            id: "dummy-service-id-" + (index + 1),
            name: translations["bookings.daily-timetable.dummy.workout" + (index + 1)],
            slugs: ["dummy-service-" + (index + 1)],
            type: ServiceType.GROUP,
        },
        occupancy: {
            status: SessionOccupancyStatus.AVAILABLE,
            availableWaitingListSpots: 0,
            availableSpots: availableSpots,
            isBookedByMember: false,
        },
        displayData: {
            startTime: getLocalizedTime(start.valueOf()),
            startDate: new Date(start.valueOf()).toISOString().split('T')[0],
        },
        policyLimitations: {
            isTooLateToBook: false,
            isTooEarlyToBook: false,
            isNoBookFlow: false,
            isBlockedByActiveFeatures: false,
        },
        staffMember: {
            id: "dummy-staff-id-" + (index + 1),
            name: translations["bookings.daily-timetable.dummy.name" + (index + 1)],
        },
        bookingInfo: {
            start: start.valueOf(),
            end: start.clone().add(30, 'minutes').valueOf(),
            scheduleId: "dummy-schedule-id-" + (index + 1),
        },
    };
};
var createDummyData = function (translations, getLocalizedTime) { return [
    createDummyDataSlot({
        translations: translations,
        index: 0,
        getLocalizedTime: getLocalizedTime,
        availableSpots: 16,
    }),
    createDummyDataSlot({
        translations: translations,
        index: 1,
        getLocalizedTime: getLocalizedTime,
        availableSpots: 10,
    }),
    createDummyDataSlot({
        translations: translations,
        index: 2,
        getLocalizedTime: getLocalizedTime,
        availableSpots: 12,
    }),
]; };
var SlotsListViewModel = /** @class */ (function () {
    function SlotsListViewModel(_a) {
        var _this = this;
        var $widget = _a.$widget, $w = _a.$w, wixSdkAdapter = _a.wixSdkAdapter, biLogger = _a.biLogger, bookingsApi = _a.bookingsApi, _b = _a.isDisplayBookButtonOnTTEnabled, isDisplayBookButtonOnTTEnabled = _b === void 0 ? false : _b, timetableSettings = _a.timetableSettings;
        this.isRtl = false;
        this.isMobile = false;
        this.isLoading = false;
        this.isAnimating = false;
        this.translations = {};
        this.timezone = 'UTC';
        this.isRendered = false;
        this.animateLoader = function () {
            var duration = 400;
            var delay = 100;
            return Promise.all([
                _this.$w('#vectorImage3')
                    .show('zoom', { duration: duration, delay: 3 * delay })
                    .then(function () { return _this.$w('#vectorImage3').hide('zoom', { duration: duration }); }),
                _this.$w('#vectorImage2')
                    .show('zoom', { duration: duration, delay: 2 * delay })
                    .then(function () { return _this.$w('#vectorImage2').hide('zoom', { duration: duration }); }),
                _this.$w('#vectorImage1')
                    .show('zoom', { duration: duration, delay: delay })
                    .then(function () { return _this.$w('#vectorImage1').hide('zoom', { duration: duration }); }),
            ]);
        };
        this.$w = $w;
        this.$widget = $widget;
        this.wixSdkAdapter = wixSdkAdapter;
        this.bookingsApi = bookingsApi;
        this.isMobile = this.wixSdkAdapter.getDeviceType() === 'Mobile';
        this.isRtl = this.wixSdkAdapter.isViewDirectionRtl();
        this.biLogger = biLogger;
        this.isDisplayBookButtonOnTTEnabled = isDisplayBookButtonOnTTEnabled;
        this.settings = timetableSettings;
        this.setupReadyListeners();
    }
    SlotsListViewModel.prototype.setLoading = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.switchState(SlotRepeaterState.LOADING)];
                    case 1:
                        _a.sent();
                        this.startAnimation();
                        return [2 /*return*/, this.startLoaderAnimation()];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setListLoaded = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = false;
                        this.stopAnimation();
                        return [4 /*yield*/, this.switchState(SlotRepeaterState.LIST)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setNoClassesState = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = false;
                        this.stopAnimation();
                        return [4 /*yield*/, this.switchState(SlotRepeaterState.NO_CLASSES)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setSlots = function (slots, shouldFocusFirstItem) {
        if (shouldFocusFirstItem === void 0) { shouldFocusFirstItem = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.slotsRepeater.data = slots
                            .sort(function (slot1, slot2) {
                            return slot1.bookingInfo.start - slot2.bookingInfo.start;
                        })
                            .map(function (slot, index) { return (__assign(__assign({}, slot), { _id: slot.id, isFocused: shouldFocusFirstItem && index === 0 })); });
                        return [4 /*yield*/, this.setListLoaded()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setCleanMode = function () {
        this.slotsRepeater.data = [];
    };
    SlotsListViewModel.prototype.setSlotsList = function (slots, translations, timezone, shouldFocusFirstItem) {
        if (shouldFocusFirstItem === void 0) { shouldFocusFirstItem = false; }
        return __awaiter(this, void 0, void 0, function () {
            var getLocalizedTime;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.translations = translations;
                        this.timezone = timezone;
                        if (!(slots && slots.length)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setSlots(slots, shouldFocusFirstItem)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        if (!this.wixSdkAdapter.isEditorMode()) return [3 /*break*/, 4];
                        getLocalizedTime = this.getLocalizedTimeFormatter(this.wixSdkAdapter, this.timezone);
                        return [4 /*yield*/, this.setSlots(createDummyData(translations, getLocalizedTime))];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        this.slotsRepeater.data = [];
                        return [4 /*yield*/, this.setNoClassesState()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setViewLoaded = function () {
        this.isRendered = true;
    };
    SlotsListViewModel.prototype.stopAnimation = function () {
        this.isAnimating = false;
    };
    SlotsListViewModel.prototype.startAnimation = function () {
        this.isAnimating = true;
    };
    SlotsListViewModel.prototype.getSlotCtaText = function (itemData) {
        if (itemData.occupancy.isBookedByMember) {
            return (this.settings[DailyTimetableSettingsKeys.BUTTON_DISABLED_TEXT_BOOKED] ||
                this.translations['bookings.daily-timetable.cta.defaults.booked']);
        }
        if (itemData.policyLimitations.isNoBookFlow) {
            return (this.settings[DailyTimetableSettingsKeys.BUTTON_ENABLED_TEXT_MORE_INFO] ||
                this.translations['bookings.daily-timetable.cta.defaults.more-info']);
        }
        if (itemData.occupancy.status === SessionOccupancyStatus.FULL) {
            return (this.settings[DailyTimetableSettingsKeys.BUTTON_DISABLED_TEXT_FULL] ||
                this.translations['bookings.daily-timetable.cta.defaults.full']);
        }
        if (itemData.occupancy.status === SessionOccupancyStatus.WAITLIST_AVAILABLE) {
            return (this.settings[DailyTimetableSettingsKeys.BUTTON_ENABLED_TEXT_WAITING_LIST] ||
                this.translations['bookings.daily-timetable.cta.defaults.waiting-list']);
        }
        if (itemData.policyLimitations.isTooLateToBook) {
            return (this.settings[DailyTimetableSettingsKeys.BUTTON_DISABLED_TEXT_CLOSED] ||
                this.translations['bookings.daily-timetable.cta.defaults.closed']);
        }
        return (this.settings[DailyTimetableSettingsKeys.BUTTON_ENABLED_TEXT_BOOK_NOW] ||
            this.translations['bookings.daily-timetable.cta.defaults.book-now']);
    };
    SlotsListViewModel.prototype.shouldDisableCta = function (itemData) {
        if (itemData.policyLimitations.isNoBookFlow) {
            return false;
        }
        return (itemData.occupancy.status === SessionOccupancyStatus.FULL ||
            itemData.policyLimitations.isTooEarlyToBook ||
            itemData.policyLimitations.isTooLateToBook ||
            itemData.occupancy.isBookedByMember);
    };
    SlotsListViewModel.prototype.navigateToSelectedSection = function (itemData) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var sendClickEventWithAction;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        sendClickEventWithAction = function (action) {
                            return _this.biLogger.sendTimeTableClickEvent({
                                serviceId: itemData.service.id,
                                type: ServiceType.GROUP,
                                isNoBookFlow: itemData.policyLimitations.isNoBookFlow,
                                isOverEditor: _this.wixSdkAdapter.isEditorMode(),
                                isPreviewMode: _this.wixSdkAdapter.isPreviewMode(),
                                action: action,
                            });
                        };
                        if (!itemData.policyLimitations.isNoBookFlow) return [3 /*break*/, 2];
                        sendClickEventWithAction(TimetableActionType.NAVIGATE_TO_SERVICE_PAGE);
                        return [4 /*yield*/, this.wixSdkAdapter.navigateToBookingsServicePage(itemData.service.slugs[0], {
                                referral: WidgetReferralInfo.TIME_TABLE,
                                location: (_b = (_a = itemData.location) === null || _a === void 0 ? void 0 : _a.businessLocation) === null || _b === void 0 ? void 0 : _b.id,
                            })];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 11];
                    case 2:
                        if (!(!this.wixSdkAdapter.isTemplateMode() &&
                            itemData.policyLimitations.isBlockedByActiveFeatures)) return [3 /*break*/, 7];
                        if (!this.wixSdkAdapter.isPreviewMode()) return [3 /*break*/, 4];
                        sendClickEventWithAction(TimetableActionType.OPEN_OWNER_PREMIUM_MODAL);
                        return [4 /*yield*/, this.wixSdkAdapter.openPreviewPremiumModal(itemData.service.type, WidgetReferralInfo.TIME_TABLE)];
                    case 3:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        sendClickEventWithAction(TimetableActionType.OPEN_UOU_PREMIUM_MODAL);
                        void this.bookingsApi.notifyOwnerNonPremium();
                        void this.biLogger.sendTimetablePremiumPrevention();
                        return [4 /*yield*/, this.wixSdkAdapter.openUoUPremiumModal(itemData.service.type, WidgetReferralInfo.TIME_TABLE)];
                    case 5:
                        _c.sent();
                        _c.label = 6;
                    case 6: return [3 /*break*/, 11];
                    case 7:
                        if (!(itemData.occupancy.status === SessionOccupancyStatus.WAITLIST_AVAILABLE)) return [3 /*break*/, 9];
                        sendClickEventWithAction(TimetableActionType.OPEN_WAITING_LIST_MODAL);
                        return [4 /*yield*/, this.wixSdkAdapter.openWaitingListModal(itemData.service.type)];
                    case 8:
                        _c.sent();
                        return [3 /*break*/, 11];
                    case 9:
                        sendClickEventWithAction(TimetableActionType.NAVIGATE_TO_CONTACT_FORM);
                        return [4 /*yield*/, this.wixSdkAdapter.navigateToBookingsSessionPage(itemData, WidgetReferralInfo.TIME_TABLE)];
                    case 10:
                        _c.sent();
                        _c.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.setupReadyListeners = function () {
        var _this = this;
        this.slotsRepeater.onItemReady(function ($item, itemData, index) {
            $item('#serviceName').text = itemData.service.name;
            $item('#time').text = itemData.displayData.startTime;
            $item('#spots').text = _this.getSpotsString(itemData.occupancy.availableSpots);
            $item('#staffMember').text = _this.getSessionInfoString(itemData.staffMember, itemData.location);
            $item('#duration').text = _this.getDurationString(itemData.bookingInfo.start, itemData.bookingInfo.end);
            if (_this.isDisplayBookButtonOnTTEnabled) {
                $item('#bookButton').label = _this.getSlotCtaText(itemData);
                if (_this.shouldDisableCta(itemData)) {
                    $item('#bookButton').disable();
                }
                $item('#bookButton').onClick(function () {
                    void _this.navigateToSelectedSection(itemData);
                });
            }
            else {
                $item('#bookButton').collapse();
            }
            if (itemData.isFocused) {
                $item('#bookButton').focus();
            }
        });
    };
    Object.defineProperty(SlotsListViewModel.prototype, "slotsRepeater", {
        get: function () {
            return this.$w('#slotRepeater');
        },
        enumerable: false,
        configurable: true
    });
    SlotsListViewModel.prototype.getSessionInfoString = function (staffMember, location) {
        var staffText = staffMember && staffMember.name;
        var locationText;
        if (location && location.type === ServiceLocationType.OWNER_CUSTOM) {
            locationText = location.locationText;
        }
        else if (location && location.businessLocation) {
            locationText = location.businessLocation.name;
        }
        var sessionInfo = __spreadArrays((staffText ? [staffText] : []), (locationText ? [locationText] : []));
        return sessionInfo.join(', ');
    };
    SlotsListViewModel.prototype.getLocalizedTimeFormatter = function (wixSdkAdapter, timezone) {
        return function (timestamp) {
            return new Date(timestamp).toLocaleTimeString(wixSdkAdapter.getRegionalSettings(), {
                timeZone: timezone,
                hour: '2-digit',
                minute: '2-digit',
            });
        };
    };
    SlotsListViewModel.prototype.switchState = function (targetState) {
        return __awaiter(this, void 0, void 0, function () {
            var changeStatePromise, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        changeStatePromise = this.$w('#statebox').changeState(targetState);
                        if (!this.isRendered) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, changeStatePromise];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        // WA for https://jira.wixpress.com/browse/WEED-20100
                        console.error('failed to change state to: ', targetState, ' caused by ', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    SlotsListViewModel.prototype.getSpotsString = function (availableSpots) {
        var formatString = this.translations[availableSpots === 0
            ? 'bookings.daily-timetable.available-spot.none'
            : availableSpots === 1
                ? 'bookings.daily-timetable.available-spot.single'
                : 'bookings.daily-timetable.available-spot.multiple'];
        return format(formatString, availableSpots);
    };
    SlotsListViewModel.prototype.getDurationString = function (start, end) {
        var _a = this.getDuration(start, end), min = _a.min, hr = _a.hr;
        var minFormatString = this.translations[min === 1
            ? 'bookings.daily-timetable.min.single'
            : 'bookings.daily-timetable.min.multiple'];
        var hrFormatString = this.translations[hr === 1
            ? 'bookings.daily-timetable.hours.single'
            : 'bookings.daily-timetable.hours.multiple'];
        return format(this.translations['bookings.daily-timetable.duration'] || '{0} {1}', hr ? format(hrFormatString, hr) : '', min || !hr ? format(minFormatString, min) : '').trim();
    };
    SlotsListViewModel.prototype.getDuration = function (start, end) {
        var durationTime = moment.duration(end - start, 'milliseconds');
        return {
            min: durationTime.minutes(),
            hr: Math.floor(durationTime.asHours()),
        };
    };
    SlotsListViewModel.prototype.getDurationStringInMinutes = function (start, end) {
        var min = this.getDurationInMin(start, end);
        var formatString = this.translations[min === 1
            ? 'bookings.daily-timetable.min.single'
            : 'bookings.daily-timetable.min.multiple'];
        return format(formatString, min);
    };
    SlotsListViewModel.prototype.getDurationInMin = function (start, end) {
        return Math.round((end - start) / 60000);
    };
    SlotsListViewModel.prototype.startLoaderAnimation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.wixSdkAdapter.isEditorMode()) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(this.loader.map(function (dot) { return dot.hide(); }))];
                    case 1:
                        _a.sent();
                        this.asyncInterval(this.animateLoader);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SlotsListViewModel.prototype.asyncInterval = function (func) {
        var _this = this;
        func().then(function () { return _this.isLoading && _this.isAnimating && _this.asyncInterval(func); });
    };
    Object.defineProperty(SlotsListViewModel.prototype, "loader", {
        get: function () {
            return [
                this.$w('#vectorImage1'),
                this.$w('#vectorImage2'),
                this.$w('#vectorImage3'),
            ];
        },
        enumerable: false,
        configurable: true
    });
    return SlotsListViewModel;
}());
export { SlotsListViewModel };
//# sourceMappingURL=slots-list.view-model.js.map